import React from 'react';
import { Plane, TrainFront, MapPin, ExternalLink } from 'lucide-react';

const travelOptions = [
  {
    icon: Plane,
    label: 'Nearest Airport',
    name: 'Rajmata Vijayaraje Scindia Airport',
    location: 'Maharajpura, Gwalior, Madhya Pradesh',
    mapLink: 'https://maps.app.goo.gl/JLP9EZPwPweYoA9b6?g_st=iw',
  },
  {
    icon: TrainFront,
    label: 'Railway Station',
    name: 'Gwalior Junction Railway Station',
    location: 'Gwalior, Madhya Pradesh',
    mapLink: 'https://maps.app.goo.gl/KqwBrssPz2xmJcad6?g_st=iw',
  },
  {
    icon: Plane,
    label: 'Major Airport (via Delhi)',
    name: 'Indira Gandhi International Airport',
    location: 'New Delhi',
    mapLink: 'https://maps.app.goo.gl/v2b2TwtqbFqEF8nHA?g_st=iw',
  },
];

const Footer = () => {
  return (
    <footer className="py-16 md:py-20" style={{ backgroundColor: '#2C1F0A' }}>
      <div className="max-w-[700px] mx-auto px-6 text-center">
        {/* Monogram */}
        <h2
          className="font-script text-[2.8rem] md:text-[3.2rem] leading-none mb-3"
          style={{ color: '#D4B96A' }}
        >
          #RitNik
        </h2>

        {/* Wedding Date */}
        <p
          className="font-cinzel text-sm md:text-base tracking-[0.3em] mb-8"
          style={{ color: '#C8A951' }}
        >
          25 APRIL 2026
        </p>

        {/* SVG wave ornament */}
        <div className="flex justify-center mb-8">
          <svg width="120" height="20" viewBox="0 0 120 20" fill="none" opacity="0.25">
            <path
              d="M0 10 C15 2, 25 18, 40 10 C55 2, 65 18, 80 10 C95 2, 105 18, 120 10"
              stroke="#C8A951"
              strokeWidth="1.2"
              fill="none"
            />
          </svg>
        </div>

        {/* How to Reach */}
        <div className="mb-10">
          <div className="flex items-center justify-center gap-2 mb-1">
            <MapPin size={16} style={{ color: '#C8A951' }} />
            <h3
              className="font-cinzel text-xs md:text-sm tracking-[0.25em] uppercase"
              style={{ color: '#C8A951' }}
            >
              How to Reach Gwalior
            </h3>
          </div>
          <p
            className="font-body text-[11px] md:text-xs mb-6 italic"
            style={{ color: 'rgba(255, 253, 245, 0.35)' }}
          >
            Plan your journey to be with us
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {travelOptions.map((opt) => (
              <a
                key={opt.name}
                href={opt.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="group rounded-xl px-4 py-5 transition-all duration-300 hover:scale-[1.03]"
                style={{
                  backgroundColor: 'rgba(200, 169, 81, 0.06)',
                  border: '1px solid rgba(200, 169, 81, 0.12)',
                }}
                aria-label={`${opt.label}: ${opt.name} — open in Google Maps`}
              >
                <opt.icon
                  size={22}
                  className="mx-auto mb-3 transition-colors duration-300"
                  style={{ color: 'rgba(200, 169, 81, 0.6)' }}
                />
                <p
                  className="font-cinzel text-[10px] tracking-[0.15em] uppercase mb-1.5"
                  style={{ color: 'rgba(200, 169, 81, 0.7)' }}
                >
                  {opt.label}
                </p>
                <p
                  className="font-body text-[13px] md:text-sm font-medium leading-snug mb-1"
                  style={{ color: 'rgba(255, 253, 245, 0.75)' }}
                >
                  {opt.name}
                </p>
                <p
                  className="font-body text-[11px] mb-3"
                  style={{ color: 'rgba(255, 253, 245, 0.3)' }}
                >
                  {opt.location}
                </p>
                <span
                  className="inline-flex items-center gap-1 font-cinzel text-[10px] tracking-[0.1em] uppercase group-hover:underline"
                  style={{ color: 'rgba(200, 169, 81, 0.5)' }}
                >
                  View on Maps <ExternalLink size={10} />
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* Thin gold horizontal rule */}
        <div className="w-full h-[0.5px] mx-auto mb-8" style={{ backgroundColor: 'rgba(200, 169, 81, 0.2)' }}></div>

        {/* Thank-you text */}
        <p
          className="font-body italic text-sm md:text-[15px] leading-[1.9] mb-10 max-w-[520px] mx-auto whitespace-pre-line"
          style={{ color: 'rgba(255, 253, 245, 0.5)' }}
        >
          With joyful hearts, we invite you to be a part of our special day. ✨{'\n'}Come, celebrate with us, and bless our journey of togetherness. 💞{'\n'}As we begin this new chapter of love and companionship, 🌸{'\n'}your presence will make our celebration truly complete. 🤍
        </p>

        {/* Bottom credit */}
        <p
          className="font-cinzel text-[0.7rem] tracking-[0.25em] uppercase"
          style={{ color: 'rgba(200, 169, 81, 0.75)' }}
        >
          MADE WITH LOVE &middot; NIHARIKA &amp; RITIK &middot; 2026
        </p>
      </div>
    </footer>
  );
};

export default Footer;
